var map = {
	"./ca.json": [
		21308,
		308
	],
	"./de.json": [
		16494,
		494
	],
	"./en.json": [
		59748,
		748
	],
	"./es.json": [
		60124,
		124
	],
	"./eu.json": [
		60968,
		968
	],
	"./fr.json": [
		43851,
		851
	],
	"./it.json": [
		45361,
		361
	],
	"./ja.json": [
		84328,
		328
	],
	"./nl.json": [
		5706,
		706
	],
	"./pt.json": [
		82275,
		275
	],
	"./pt_BR.json": [
		14943,
		943
	],
	"./ro.json": [
		51640,
		640
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 71539;
module.exports = webpackAsyncContext;